import Button from '@/components/Button';
import Input from '@/components/Input';
import LayoutStandard from '@/components/LayoutStandard';
import Divider from '@/components/LoginPage/OrContinueWithDivider';

interface Props {
  onNext: () => void;
  onManual: () => void;
  linkedInUrl: string;
  onLinkedInUrlChange: (url: string) => void;
}

function OnboardingStepOne({ onNext, onManual, linkedInUrl, onLinkedInUrlChange }: Props) {
  return (
    <LayoutStandard
      heading="Create your Tapt profile"
      backgroundColor="bg-gray-50"
    >
      <div className="sm:mx-auto sm:w-full sm:max-w-md lg:max-w-lg">
        <div className="bg-white py-2 px-4 sm:rounded-lg sm:px-10 sm:py-8 lg:border lg:border-gray-100">
          <div className="space-y-4">
            <div>
              <div className="flex items-center justify-between mb-1">
                <label
                  htmlFor="linkedin-url"
                  className="block text-sm font-medium text-gray-900"
                >
                  Enter a LinkedIn profile URL
                </label>
                <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-700">
                  Takes 30 seconds
                </span>
              </div>
              <Input
                id="linkedin-url"
                label=""
                placeholder="https://linkedin.com/in/yourname"
                type="url"
                value={linkedInUrl}
                onChange={onLinkedInUrlChange}
              />
              <p className="mt-1.5 text-sm text-gray-500">
                <a
                  href="https://www.linkedin.com/in/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-brand-500 hover:text-brand-600 underline"
                >
                  Click here to get your LinkedIn profile URL
                </a>
              </p>
            </div>

            <Button
              buttonText="Get started"
              kind="primary"
              fullWidth
              onClick={onNext}
              disabled={!linkedInUrl.trim()}
            />
          </div>

          <Divider text="or" className="mt-6" />

          <div className="mt-6">
            <Button
              buttonText="Create manually"
              kind="white"
              fullWidth
              onClick={onManual}
            />
          </div>
        </div>
      </div>
    </LayoutStandard>
  );
}

export default OnboardingStepOne;
